<template>
  <div>
    <b-tabs pills card>
      <b-tab title="Creacion Rutas" active>
        <b-card class="text-center" title="Creacion de rutas">
          <b-row>
            <b-col :md=" id_ruta!=null? 10:''">
              <b-form-select v-model="id_ruta" class="mb-3" :options="select_rutas" @change="obtenerDataRutas($event)"></b-form-select>
            </b-col>
            <b-col md="2" v-if="id_ruta==0">
              <b-btn block variant="info" @click="guardar">Guardar</b-btn>
            </b-col>
            <b-col md="2" v-if="id_ruta!=0 && id_ruta!=null ">
              <b-btn block variant="warning" @click="editar">
                <i class="fa fa-edit"></i> Editar
              </b-btn>
              <b-btn block variant="danger" @click="mensajeEliminar">
                <i class="fa fa-trash"></i> Eliminar
              </b-btn>
            </b-col>
            <b-col md="2" v-if="id_ruta!=0 && id_ruta!=null "></b-col>
          </b-row>
        </b-card>
        <b-card class="text-left" v-if="ver_card">
          <b-row>
            <b-col md="6">
              <br>
              <label for="NombreRuta">Nombre Ruta</label>
              <b-form-input v-model="nombreRuta" type="text" placeholder="Nombre Ruta"></b-form-input>
            </b-col>
            <b-col md="6">
              <br>
              <label for="Hora">Hora inicio</label>
              <b-input-group>
                <b-input-group-prepend>
                  <b-input-group-text>
                    <i class="fa fa-clock-o"></i>
                  </b-input-group-text>
                </b-input-group-prepend>
                <b-form-input type="time" required v-model="hora"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col md="3">
              <br>
              <label for="nombre">Buscar Conductores</label>
              <input v-model="idCO" type="text" class="form-control" placeholder="Doc. Identificacion" @keypress="onlyNumbers" text="Buscar" @change="consultarCO">
            </b-col>
            <b-col md="3">
              <br>
              <label for="Numbreu">Nombre Conductor</label>
              <b-form-input v-model="nombreConductor" type="text" placeholder="Nombre Usuario" disabled></b-form-input>
            </b-col>
            <b-col md="3">
              <br>
              <label for="nombre">Buscar Monitores</label>
              <input v-model="idMO" type="text" class="form-control" @keypress="onlyNumbers" placeholder="Doc. Identificacion" text="Buscar" @change="consultarMO">
            </b-col>
            <b-col md="3">
              <br>
              <label for="Numbreu">Nombre Monitor</label>
              <b-form-input v-model="nombreMonitor" type="text" placeholder="Nombre Usuario" disabled></b-form-input>
            </b-col>
            <b-col md="3">
              <br>
              <label for="nombre">Buscar Vehiculos</label>
              <input v-model="placa_vehiculo" type="text" class="form-control" placeholder="No. de placa" text="Buscar" @change="consultarVehiculo">
            </b-col>
            <b-col md="3">
              <br>
              <label for="Numbreu">Nombre Vehiculo</label>
              <b-form-input v-model="nombre_vehiculo" type="text" disabled></b-form-input>
            </b-col>
            <b-col md="6">
              <br>
              <b-form-group label="Horario de ruta">
                <b-form-radio-group buttons v-model="id_jornada" button-variant="outline-success" size="lg" :options="options_jornada_ruta" name="radioBtnOutline" />
              </b-form-group>
            </b-col>
  
            <b-col md="12">
              <br>
              <label for="Observaciones">Observaciones</label>
              <b-form-textarea id="textarea1" placeholder :rows="3" :max-rows="6" v-model="observaciones"></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
        <b-card v-if="ver_card">
          <b-col>
            <b-row>
              <b-col>
                <b-card title="Filtro">
                  <b-row>
                    <b-col md="5">
                      <b-form-select v-model="curso" class="mb-3" :options="select_curso"></b-form-select>
                    </b-col>
                    <b-col md="5">
                      <input v-model="apellido_alumno" type="text" class="form-control" placeholder="Apellido a buscar">
                    </b-col>
                    <b-col md="2">
                      <b-btn block @click="alumnoBuscar">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-col>
                  </b-row>
                  <br>
                  <b-row>
                    <b-col style="height: 120px;" class="text-center" md="2" v-for="(filtro) in alumnos_filtro" :key="filtro.index">
                      <b-img :src="filtro.img" @click="alumnoAdd_message(filtro)" fluid-grow class="img-avatar" style="height: auto;" />
                      <small>{{ filtro.name.split(" ").length>2 ? filtro.name.split(" ")[0] + " " +filtro.name.split(" ")[2]  : filtro.name }}</small>
                    </b-col>
                  </b-row>
                </b-card>
              </b-col>
              <b-col>
                <b-card title="Estudiantes en la ruta" v-if="ver_estudiantes_ruta">
                  <b-row>
                    <table class="table text-center">
                      <th></th>
                      <th>Estudiante</th>
                      <th>Lunes</th>
                      <th>Martes</th>
                      <th>Miercoles</th>
                      <th>Jueves</th>
                      <th>Viernes</th>
                      <tr v-for="(alumno,index) in alumnos_ruta" :key="alumno.index">
                        <td>
                          <div>{{index + 1}}</div>
                          <div>
                            <i style="cursor:pointer" v-if="index != 0 " @click="ordenarRutaAsc(index)" class="fa fa-chevron-up"></i>
                            <br>
                            <i style="cursor:pointer" v-if="index != (alumnos_ruta.length-1)" @click="ordernarRutaDes(index)" class="fa fa-chevron-down"></i>
                          </div>
                        </td>
                        <td>
                          <b-img :src="alumno.img" @click="alumnoShow(alumno)" fluid class="img-avatar" style="height: 30px;width:30px" /> <br>
                          <small>{{ alumno.name.split(" ").length>2 ? alumno.name.split(" ")[0] + " " +alumno.name.split(" ")[2]  : alumno.name }}</small>
                        </td>
                        <td v-for="(dia) in dias_base" :key="dia.index">
                          <b-btn @click="alumnoDias(index,dia)" size="sm" :variant="!ValidarDia(index,dia)? '': 'success' ">
                            <i class="fa fa-check"></i>
                          </b-btn>
                        </td>
                        <td>
                          <b-btn size="sm" variant="danger" @click="alumnoRemove(index)">
                            <i class="fa fa-times"></i>
                          </b-btn>
                        </td>
                      </tr>
                    </table>
                    <b-col md="2"></b-col>
                  </b-row>
                </b-card>
              </b-col>
            </b-row>
          </b-col>
        </b-card>
        <b-card v-if="ver_map">
          <gmap-map ref="mymap" :center="center" :zoom="17" style="width: 100%; height: 300px">
            <GmapMarker
              :key="index"
              v-for="(m, index) in path"
              :position="m"
              :draggable="false" 
            />
          <gmap-polyline v-bind:path.sync="path" v-bind:options="{ strokeColor:'#008000'}">
         </gmap-polyline>
        </gmap-map>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
  import List from "@/components/modules/base/list.vue";
  import GoogleMap from "@/components/modules/base/GoogleMap.vue";
  export default {
    name: "Lists",
    data() {
      return {
        nombreRuta: "",
        hora: "",
        idCO: "",
        idMO: "",
        idUserAl: "",
        idUserCO: "",
        idUserMO: "",
        id_vehiculo: "",
        nombreConductor: "",
        nombreMonitor: "",
        nombreAlumno: "",
        nombre_vehiculo: "",
        selectedCurso: "",
        selectedDias: "",
        apellido_alumno: "",
        placa_vehiculo: "",
        observaciones: "",
        currentPlace: null,
        show: false,
        ver_estudiantes_ruta: true,
        ver_card: false,
        ver_map: false,
        curso: null,
        id_ruta: null,
        id_jornada: 1,
        center: {},
        markers: [],
        select_curso: [],
        select_rutas: [],
        alumnos_ruta: [],
        alumnos_del_ruta: [],
        alumnos_filtro: [],
        path: [],
        options_jornada_ruta: [{
            text: "Jornada Mañana",
            value: 1
          },
          {
            text: "Jornada Tarde",
            value: 2
          }
        ],
        dias_base: [1, 2, 3, 4, 5]
      };
    },
    mounted() {
      this.obtenerTodosCursos();
      this.consultarRutas();
      this.verCoordenadas()
    },
    components: {
      List,
      GoogleMap
    },
    methods: {
      setPlace(place) {
        let lat = place.geometry.location.lat()
        let lng = place.geometry.location.lng()
        this.center = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          };
      },
      addMarker() {
        if (this.currentPlace) {
          const marker = {
            lat: this.currentPlace.geometry.location.lat(),
            lng: this.currentPlace.geometry.location.lng()
          };
          this.markers.push({
            position: marker
          });
          this.places.push(this.currentPlace);
          this.center = marker;
          this.currentPlace = null;
        }
      },
      verCoordenadas() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      },
      updateCoordinates(location) {
        let coordinates = {
          lat: location.latLng.lat(),
          lng: location.latLng.lng(),
        };
        console.log("market 2", coordinates);
      },
      alumnoAdd_message(alumno) {
        this.$root.showInfoDialog(
          "Informacion de estudiante",
          "<strong>Nombre: </strong>" +
          alumno.name +
          " <br> <strong>Documento: </strong> " +
          alumno.num_doc,
          "Agregar",
          () => {
            this.alumnoAdd(alumno);
          },
          "Cancelar"
        );
      },
      alumnoShow(alumno) {
        this.$root.showInfoDialog(
          "Informacion de estudiante",
          "<strong>Nombre: </strong>" +
          alumno.name +
          " <br> <strong>Documento: </strong> " +
          alumno.num_doc,
          "Aceptar"
        );
      },
      alumnoDias(index_alumno, idDia) {
        let exist = this.ValidarDia(index_alumno, idDia);
        if (exist) {
          this.removerDias(index_alumno, idDia);
        } else {
          this.agregarDias(index_alumno, idDia);
        }
      },
      alumnoBuscar() {
        if (!this.curso && !this.apellido_alumno) {
          this.$root.showInfoDialog(
            "Mensaje informativo",
            "Debe seleccionar por lo menos un campo",
            "Aceptar"
          );
          return;
        }
        let data = {
          apellido: this.apellido_alumno,
          curso: this.curso
        };
        this.$store.dispatch("academicCoursesStudents", data).then(response => {
          this.alumnos_filtro = this.$store.getters.academicCourse;
          this.alumnos_filtro = this.urlToImage(this.alumnos_filtro);
        });
      },
      urlToImage(elementos) {
        elementos.forEach(element => {
          let mainPath = localStorage.getItem("urlApi");
          mainPath = mainPath.replace("/api", "");
          element.img = mainPath + element.url;
        });
        return elementos;
      },
      agregarDias(index_alumno, idDia) {
        this.alumnos_ruta[index_alumno].dias.push(idDia);
        console.log(JSON.stringify(this.alumnos_ruta));
      },
      alumnoRemove(index_alumno) {
        this.alumnos_del_ruta.push(this.alumnos_ruta[index_alumno].id_user);
        this.alumnos_ruta.splice(index_alumno, 1);
      },
      alumnoAdd(alumno) {
        let exist = false;
        let alumno_add = {
          id_user: alumno.id,
          num_doc: alumno.num_doc,
          name: alumno.name,
          img: alumno.img,
          dias: [1, 2, 3, 4, 5]
        };
        this.alumnos_ruta.forEach(element => {
          if (element.id_user == alumno.id) {
            exist = true;
          }
        });
        if (!exist) {
          this.alumnos_ruta.push(alumno_add);
        } else {
          alert("El estudiante ya se encuenta en la ruta");
          //this.$root.showInfoDialog("Mensaje informativo","El estudiante ya se encuenta en la ruta","Aceptar")
          return;
        }
      },
      onlyNumbers(event) {
        let key = window.event ? event.which : event.keyCode;
        if ((key < 48 || key > 57) && key != 8) event.preventDefault();
      },
      obtenerTodosCursos() {
        this.$store.dispatch("academicCoursesSelect").then(response => {
          this.select_curso = this.$store.getters.academicCourse;
        });
      },
      consultarCO() {
        let array = {
          id: this.idCO
        };
        this.$store
          .dispatch("schoolroutesExisteConductor", array)
          .then(Response => {
            if (this.$store.getters.schoolroutesVehicles != null) {
              this.nombreConductor = this.$store.getters.schoolroutesVehicles.name;
              this.idUserCO = this.$store.getters.schoolroutesVehicles.id;
            } else {
              this.nombreConductor = "";
              this.idUserCO = "";
              alert("No Existe Usuario");
            }
          });
      },
      consultarMO() {
        let array = {
          id: this.idMO
        };
        this.$store
          .dispatch("schoolroutesExisteMonitor", array)
          .then(Response => {
            if (this.$store.getters.schoolroutesVehicles != null) {
              this.nombreMonitor = this.$store.getters.schoolroutesVehicles.name;
              this.idUserMO = this.$store.getters.schoolroutesVehicles.id;
            } else {
              this.idUserMO = "";
              this.nombreMonitor = "";
              alert("No Existe Usuario");
            }
          });
      },
      consultarVehiculo() {
        let array = {
          placa: this.placa_vehiculo
        };
        this.$store
          .dispatch("schoolRoutesVehiculosByPlaca", array)
          .then(Response => {
            if (this.$store.getters.schoolroutesVehicles != null) {
              this.nombre_vehiculo = this.$store.getters.schoolroutesVehicles.nombre_ruta;
              this.id_vehiculo = this.$store.getters.schoolroutesVehicles.id;
            } else {
              this.nombre_vehiculo = "";
              this.id_vehiculo = "";
              alert("No Existe Vehiculo");
            }
          });
      },
      consultarRutas() {
        this.$store.dispatch("schoolroutesRoutesAll").then(response => {
          this.select_rutas = this.$store.getters.schoolroutesRoutes;
        });
      },
      ValidarDia(index_alumno, idDia) {
        let exist = false;
        this.alumnos_ruta[index_alumno].dias.forEach(element => {
          if (element == idDia) {
            exist = true;
          }
        });
        return exist;
      },
  
      ordenarRutaAsc(index) {
        this.ver_estudiantes_ruta = false;
        let aux = this.alumnos_ruta[index];
        this.alumnos_ruta[index] = this.alumnos_ruta[index - 1];
        this.alumnos_ruta[index - 1] = aux;
        this.ver_estudiantes_ruta = true;
      },
      ordernarRutaDes(index) {
        this.ver_estudiantes_ruta = false;
        let aux = this.alumnos_ruta[index];
        this.alumnos_ruta[index] = this.alumnos_ruta[index + 1];
        this.alumnos_ruta[index + 1] = aux;
        this.ver_estudiantes_ruta = true;
      },
      removerDias(index_alumno, idDia) {
        this.alumnos_ruta[index_alumno].dias.forEach(element => {
          if (element == idDia) {
            this.alumnos_ruta[index_alumno].dias.splice(
              this.alumnos_ruta[index_alumno].dias.indexOf(element),
              1
            );
          }
        });
        console.log(JSON.stringify(this.alumnos_ruta));
      },
      guardar() {
        if (this.nombreRuta && this.hora && this.idUserCO && this.idUserMO) {
          let array = {
            nombreRuta: this.nombreRuta,
            idConductor: this.idUserCO,
            idMonitor: this.idUserMO,
            idVehiculo: this.id_vehiculo,
            id_jornada: this.id_jornada,
            alumnos: this.alumnos_ruta,
            hora_inicio: this.hora,
            observaciones: this.observaciones
          };
          this.$store.dispatch("schoolroutescrearRuta", array).then(Response => {
            this.varimgtext =
              '<div style="text-align: center"><h1>Ruta Creada</h1></span></div>';
            this.$root.showInfoDialog("alerta", this.varimgtext, "Aceptar");
            this.consultarRutas();
          });
        } else {
          this.$root.showInfoDialog("Error", "Tienes Campos Vacios", "Cerrar");
        }
      },
      editar() {
        if (this.nombreRuta && this.hora && this.idUserCO && this.idUserMO) {
          let array = {
            id: this.id_ruta,
            nombreRuta: this.nombreRuta,
            idConductor: this.idUserCO,
            idMonitor: this.idUserMO,
            idVehiculo: this.id_vehiculo,
            id_jornada: this.id_jornada,
            alumnos: this.alumnos_ruta,
            hora_inicio: this.hora,
            observaciones: this.observaciones
          };
          this.$store
            .dispatch("schoolroutesRoutesUpdate", array)
            .then(Response => {
              this.varimgtext =
                '<div style="text-align: center"><h1>Ruta Actualizada</h1></span></div>';
              this.$root.showInfoDialog("alerta", this.varimgtext, "Aceptar");
              this.consultarRutas();
            });
        } else {
          this.$root.showInfoDialog("Error", "Tienes Campos Vacios", "Cerrar");
        }
      },
      mensajeEliminar() {
        this.$root.showInfoDialog(
          "Mensaje informativo",
          "¿Desea eliminar esta ruta?",
          "Si",
          () => {
            this.eliminar();
          },
          "No",
          null
        );
      },
      eliminar() {
        let data = {
          id: this.id_ruta
        };
        this.$store.dispatch("schoolroutesRoutesDelete", data).then(Response => {
          this.varimgtext =
            '<div style="text-align: center"><h1>Ruta Eliminada</h1></span></div>';
          this.$root.showInfoDialog("alerta", this.varimgtext, "Aceptar");
          this.id_ruta = null;
          this.ver_card = false;
          this.consultarRutas();
        });
      },
      limpiarData() {
        this.nombreRuta = "";
        this.nombreConductor = "";
        this.idConductor = "";
        this.idCO = "";
        this.hora = "";
        this.id_jornada = 1;
        this.idMonitor = "";
        this.nombreMonitor = "";
        this.idMO = "";
        this.id_vehiculo = "";
        this.placa_vehiculo = "";
        this.nombre_vehiculo = "";
        this.observaciones = "";
        this.alumnos_ruta = [];
      },
      obtenerDataRutas(evt) {
        let data = {
          id: evt
        };
        if (evt == 0) {
          this.limpiarData();
        } else {
          this.$store.dispatch("schoolroutesRoutesEdit", data).then(response => {
            this.nombreRuta = this.$store.getters.schoolroutesRoutes.nombreRuta;
            this.nombreConductor = this.$store.getters.schoolroutesRoutes.conductor;
            this.idUserCO = this.$store.getters.schoolroutesRoutes.idConductor;
            this.idCO = this.$store.getters.schoolroutesRoutes.doc_conductor;
            this.hora = this.$store.getters.schoolroutesRoutes.hora_inicio;
            this.id_jornada = this.$store.getters.schoolroutesRoutes.id_jornada;
            this.idUserMO = this.$store.getters.schoolroutesRoutes.idMonitor;
            this.nombreMonitor = this.$store.getters.schoolroutesRoutes.monitor;
            this.idMO = this.$store.getters.schoolroutesRoutes.doc_monitor;
            this.id_vehiculo = this.$store.getters.schoolroutesRoutes.id_vehiculo;
            this.placa_vehiculo = this.$store.getters.schoolroutesRoutes.placa;
            this.nombre_vehiculo = this.$store.getters.schoolroutesRoutes.nombre_ruta;
            this.observaciones = this.$store.getters.schoolroutesRoutes.observaciones;
            this.alumnos_ruta = this.$store.getters.schoolroutesRoutes.estudiantes;
            this.alumnos_ruta = this.urlToImage(this.alumnos_ruta);
            this.path = []
            this.alumnos_ruta.forEach(element=>{
              let cors={
                lat: Number(element.latitud),
                lng: Number(element.longitud)
              }
              this.path.push(cors)
            })
            console.log('patch',JSON.stringify(this.path))
          });
        }
        this.ver_card = true;
        this.ver_map = true 
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/modules/schoolroutes/routes/list.vue